// extracted by mini-css-extract-plugin
export default {"content":"NotFoundPlugin_content__QCtxP","title":"NotFoundPlugin_title__60WoD","description":"NotFoundPlugin_description__zSmrH","text":"NotFoundPlugin_text__61z+M"};